import { useLocation } from 'react-router-dom'

import { MenuBurger } from '../menu-burger'
import { NextPage } from '../navigation'
import { UnSdgList } from './un-sdg-list.component'
import { MediaCarousel } from './media-carousel.component'

import { IMedia, IUnSdg } from 'src/types'
import { PATHS, ROUTES } from 'src/constants'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
import { ImageSt, ImageWrapper } from './product-image.styled'

interface IProps {
  name: string
  image: string
  media: IMedia[]
  unSdg?: IUnSdg[]
  nextPageOverride?: {
    to: string
    state?: object
    label?: string
    variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
    backgroundColor?: string
    textColor?: string
  }
  menuOverride?: {
    variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
    backgroundColor?: string
    textColor?: string
    topOffset?: number
  }
}

export const ProductImage = ({
  name,
  image,
  unSdg,
  media,
  nextPageOverride,
  menuOverride,
}: IProps) => {
  const location = useLocation()

  const defaultState = {
    from: location.pathname,
    to: `${location.pathname}/${PATHS.JOURNEY}`,
    previousLabel: nextPageOverride?.label || 'Product',
  }

  const nextPageState = nextPageOverride?.state ?? defaultState
  const nextPageTo = nextPageOverride?.to ?? `${location.pathname}/${ROUTES.JOURNEY}`

  return (
    <ImageWrapper
      id="index__components-product-image__imagewrapper__l23"
      withIndicator={media.length > 1}
    >
      {media.length ? (
        <MediaCarousel media={media} />
      ) : (
        <ImageSt id="index__components-product-image__imagest__l24" alt={name} src={image} />
      )}

      {unSdg && Array.isArray(unSdg) && (
        <UnSdgList unSdg={unSdg} withIndicator={media.length > 1} />
      )}
      <MenuBurger {...menuOverride} />
      <NextPage
        to={nextPageTo}
        state={nextPageState}
        label={nextPageOverride?.label}
        variant={nextPageOverride?.variant}
        backgroundColor={nextPageOverride?.backgroundColor}
        textColor={nextPageOverride?.textColor}
      />
    </ImageWrapper>
  )
}
